<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">{{provider.title}}-{{__t('NOTIFICATIONS')}}</h5>

            <button class="btn btn-primary waves-effect waves-themed" @click="add_trigger">
                <i class="fal fa-plus mr-2"></i>{{__t('CREATE_TRIGGER')}}
            </button>
        </div>

        <order_notification_trigger
            v-for="trigger in triggers"
            :key="trigger.id || trigger._uid"
            :rest="rest"
            :provider="provider"
            :trigger="trigger"
            @removed="on_removed"
            @duplicated="on_duplicated"
        />

        <div class="text-muted" v-if="triggers.length === 0">
            {{__t('NO_TRIGGERS_YET')}}
        </div>
    </div>
</template>

<script>
import order_notification_trigger from "./order_notification_trigger.vue";

let uid_seq = 0;

export default {
    name: "order_notification_channel",
    components : {
        order_notification_trigger
    },
    props : {
        rest : {
            type : Object
        },
        provider : {
            type : Object
        }
    },
    computed: {
        triggers() {
            const list = this.rest.order_notification || [];
            return list.filter(item => item.provider_type === this.provider.type);
        }
    },
    methods : {
        add_trigger() {
            if (!Array.isArray(this.rest.order_notification)) {
                this.$set(this.rest, 'order_notification', []);
            }

            this.rest.order_notification.push({
                id: null,
                _uid: 'new_' + (++uid_seq),
                provider_type: this.provider.type,
                trigger_status: 'accept',
                message: '',
                delay_minutes: 0,
                is_active: true,
            });
        },

        on_duplicated(data) {
            if (!Array.isArray(this.rest.order_notification)) {
                this.$set(this.rest, 'order_notification', []);
            }

            this.rest.order_notification.push(data);
        },

        on_removed(trigger) {
            const list = this.rest.order_notification || [];
            const idx = list.indexOf(trigger);
            if (idx >= 0) {
                list.splice(idx, 1);
            }
        },
    },
}
</script>

<style scoped>

</style>
